export default __webpack_public_path__ + "static/media/signup_bg.ade99cd2.jpg";